// extracted by mini-css-extract-plugin
export default {"RenderModal":"RenderModal_RenderModal__24Ult"};